var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholderMapInsightProblems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 314,
    viewBox: "0 0 1920 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 314
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 314,
    rx: 8,
    fill: "#E4E4EB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -331.254,
    width: 1920,
    height: 645.254,
    rx: 8,
    fill: "#E4E4EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1981.16 -76.7199L1734.03 -158.884C1706.81 -167.943 1679.46 -177.037 1654.42 -188.73C1617.21 -205.952 1585.52 -228.477 1546.65 -243.909C1481.14 -269.945 1399.18 -274.247 1338.43 -305.111C1325.13 -311.852 1312.87 -319.876 1297.52 -324.177C1283.29 -328.162 1267.54 -328.636 1252.43 -330.708C1190.05 -339.275 1143.63 -373.862 1088.08 -394.929C1004.49 -426.531 903.998 -426.531 808.475 -430.85C664.803 -437.363 522.968 -455.639 381.262 -472.985C354.07 -476.303 321.263 -478.252 303.488 -463.961C283.126 -447.528 298.676 -421.527 322.401 -407.306C346.127 -393.086 377.045 -384.483 397.122 -367.875C425.789 -344.191 425.582 -310.676 427.393 -280.093C429.205 -249.51 438.182 -214.801 476.112 -198.175C523.796 -177.265 592.851 -195.875 640.638 -175.123C650.677 -170.769 659.292 -164.818 670.211 -161.64C692.254 -155.232 717.247 -161.394 740.43 -165.503C799.906 -175.925 862.831 -172.373 918.953 -155.425C951.061 -145.646 979.961 -131.724 1008.63 -117.89L1303.99 24.7734C1332.45 38.4499 1365.23 52.8636 1399.28 48.0005C1411.31 46.2449 1422.96 42.2069 1435.17 43.0321C1444.64 43.6641 1453.05 47.1754 1461.04 50.5989C1512.79 72.5794 1565.7 95.4554 1608.03 124.687C1626.13 137.191 1649.42 145.654 1674.79 148.948C1700.16 152.241 1726.41 150.209 1750.04 143.121C1758.35 140.628 1766.68 138.17 1775.06 135.87C1853.52 114.525 1939.07 108.092 2022.51 117.26",
    stroke: "#F2F2F5",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.019 -136.236L925.86 -104.143C905.679 -90.9934 884.878 -77.1941 875.123 -59.3743C855.434 -23.3136 884.903 21.859 852.071 53.2147C844.619 60.2372 834.477 66.0133 827.802 73.4572C806.172 97.6323 827.414 131.657 805.784 155.832C798.177 164.294 785.784 170.86 781.231 180.288C777.971 187.117 779.29 194.561 777.453 201.636C774.633 212.363 764.724 221.51 755.125 230.236C730.977 252.146 706.829 274.05 682.681 295.949C670.676 306.852 658.567 317.877 650.78 330.412C639.732 348.021 638.128 367.632 636.627 386.768C635.282 403.657 634.04 420.95 641.103 437.19C648.166 453.43 665.191 468.686 689.253 473.198",
    stroke: "#F2F2F5",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1975.73 134.131C1946.54 133.124 1917.29 133.593 1888.2 135.536C1872.55 136.589 1856.41 138.187 1843.06 143.857C1831.9 148.597 1823.63 155.813 1815.58 162.871C1795.37 180.585 1774.96 198.545 1761.74 219.051C1748.52 239.557 1743.06 263.293 1753.74 284.501C1759.77 296.545 1770.61 307.149 1781.56 317.419C1810.02 344.193 1840.8 370.317 1878.63 391.156C1916.46 411.996 1962.2 427.322 2010.76 429.78",
    stroke: "#F2F2F5",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1751.52 248.67C1727.77 246.703 1707.12 237.047 1687.56 227.69L1612.74 191.91C1586.47 179.34 1559.9 166.664 1530.1 158.553C1500.29 150.442 1466.55 146.931 1435.84 153.409C1409.97 158.886 1388.34 170.807 1367.41 182.482L1309.45 214.768C1300.99 219.509 1292.35 224.354 1286.58 230.674C1280.81 236.995 1278.12 244.878 1275.72 252.374C1261.87 295.387 1248.03 338.4 1238.82 382.028C1235.22 399.058 1232.35 416.158 1227.28 432.941C1220.63 454.224 1211.25 475.072 1199.26 495.249",
    stroke: "#F2F2F5",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.06 323.214C1190.36 334.629 1121.61 348.583 1054.11 365.016C1016.91 374.075 980.117 383.889 943.119 393.369C935.771 395.248 928.086 397.162 920.273 396.688C911.347 396.161 903.481 392.614 896.366 388.945C848.465 363.999 815.534 328.103 803.69 287.926C795.074 258.08 797.713 225.355 773.03 200.004C748.917 175.214 704.415 163.627 673.368 142.647C633.317 115.505 619.604 75.564 589.566 43.0144C555.931 6.58497 502.452 -19.6092 445.842 -38.9212C389.232 -58.2332 328.612 -71.4883 270.087 -87.9386C258.574 -91.169 246.517 -94.8734 239.48 -101.843C232.442 -108.813 231.718 -118.048 231.33 -126.633C230.019 -156.654 228.691 -186.687 227.345 -216.732C226.259 -241.68 288.043 -247.175 304.731 -269.401C317.124 -285.922 311.872 -306.849 296.141 -322.07C280.411 -337.292 255.65 -347.176 229.777 -353.145C211.899 -357.288 191.822 -359.659 174.409 -354.69C169.424 -352.958 164.312 -351.399 159.093 -350.02C144.009 -346.913 128.226 -351.986 113.996 -356.586C61.6943 -373.457 6.26042 -385.435 -50.7882 -392.191",
    stroke: "#F2F2F5",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.62 441.79C1771.46 424.567 1771.36 405.22 1770.97 386.505C1770.74 371.652 1770.33 356.185 1760.29 342.983C1745.51 323.53 1713.72 313.541 1687.14 301.234C1667.25 292.052 1648.13 278.27 1643.42 263.136C1642.29 259.606 1639.43 256.44 1635.3 254.156C1631.17 251.873 1626.03 250.607 1620.7 250.566C1604.84 250.461 1588.52 246.37 1574.6 240.805C1553.61 232.395 1535.58 220.79 1513.93 213.224C1491.73 205.481 1465.1 201.584 1449.45 188.399C1435.38 176.548 1433.93 160.203 1433.05 144.982C1432.32 130.463 1433.85 113.117 1452.17 105.568C1470.05 98.2118 1492.89 104.778 1511.44 111.379C1519.95 114.422 1528.47 117.454 1537 120.473C1547.66 124.283 1558.61 128.216 1566.42 134.518C1574.24 140.821 1578.19 149.915 1572.97 157.342C1576.51 161.151 1584.97 160.677 1591.08 158.992C1597.18 157.307 1603.78 154.814 1610.12 156.165C1615.5 157.324 1618.89 160.906 1623.81 162.767C1637.78 168.034 1653.74 157.833 1669.73 157.149C1682.98 156.604 1694.65 162.714 1707.48 164.996C1724.63 168.051 1743.21 163.908 1757.57 156.833C1771.93 149.757 1783.06 139.873 1793.66 130.27",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.67 27.2482C1028.66 23.5964 1024.02 15.2572 1014.32 11.2543C1009.64 9.55005 1004.57 8.39273 999.315 7.83082L865.527 -11.6743C828.011 -17.1519 789.693 -22.6646 751.686 -19.68C725.425 -17.6435 700.225 -11.6216 675.413 -5.45936C640.303 3.31882 603.279 13.5191 582.115 34.4463",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2222 -456.728C79.5078 -425.127 129.391 -406.675 178.342 -394.456C227.294 -382.237 279.453 -373.897 322.402 -353.795C332.027 -349.301 341.523 -343.841 345.326 -336.327C351.949 -323.212 339.685 -306.955 351.509 -295.648C354.692 -292.594 359.271 -290.382 362.273 -287.169C365.021 -283.692 366.677 -279.866 367.137 -275.933C373.087 -248.931 377.486 -218.12 351.277 -197.438C344.575 -192.171 336.063 -187.765 331.147 -181.637C326.232 -175.51 326.464 -166.521 335.235 -162.852C352.596 -155.584 379.4 -175.896 392.544 -165.31C396.114 -162.448 396.477 -158.41 398.52 -154.934C405.61 -142.873 429.102 -141.1 448.196 -140.152C485.572 -138.293 522.263 -132.365 556.862 -122.595C602.192 -109.832 644.339 -90.4145 692.773 -85.0598C744.312 -79.3715 796.963 -90.3267 849.019 -87.5528C928.449 -83.3217 995.977 -48.2441 1058.33 -14.606C1089.84 2.38853 1128.19 18.1366 1163.27 31.4092C1183.14 38.8882 1203.94 45.4543 1221.93 54.8469C1239.91 64.2396 1255.15 77.2138 1258.74 92.4352C1259.67 96.4204 1259.83 100.581 1262.03 104.338C1263.58 106.94 1266.04 109.247 1269.19 111.06C1272.35 112.874 1276.1 114.14 1280.14 114.749C1286.22 115.645 1293.62 114.556 1296.49 110.799C1298.12 108.692 1297.99 106.182 1298.61 103.777C1300.94 94.9984 1314.14 88.9414 1327.36 88.6956C1340.58 88.4499 1352.89 92.9794 1362.65 98.931C1370.07 103.461 1376.49 109.114 1378.61 115.732C1380.73 122.351 1377.76 130.023 1369.61 133.921C1366.06 135.677 1361.46 136.765 1359.7 139.451C1357.73 142.418 1360.19 145.807 1362.7 148.563C1370.84 157.471 1380.46 165.718 1391.37 173.142C1443.53 208.571 1497.81 243.876 1553.05 277.198C1558.95 280.71 1564.95 284.555 1567.64 289.576C1571.11 295.949 1568.6 303.059 1565.54 309.52C1559.62 321.381 1552.77 333.02 1545.03 344.387C1541.25 350.887 1536.37 357.068 1530.49 362.803C1523.03 369.527 1513 374.689 1503.09 379.745C1496.18 383.256 1488.96 386.943 1480.47 388.225C1471.99 389.507 1461.9 387.733 1457.68 382.589C1445.36 388.86 1435.47 397.065 1428.86 406.501C1425.6 411.171 1422.31 416.684 1415.07 418.264C1408.91 419.633 1402.34 417.527 1395.84 417.298C1372.87 416.543 1361.87 437.769 1340.11 442.878",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408.31 315.682L1286.06 232.728",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.77 347.284L1265.7 282.097L1039.49 188.434L1127.67 93.0679L1188.24 16.3115C1185.94 13.3335 1182.72 10.7305 1178.79 8.68389C1174.87 6.63727 1170.33 5.19617 1165.5 4.46091C1148.32 1.45877 1148.89 -9.07503 1139.44 -13.2183C1130 -17.3616 1114.58 -11.7436 1085.76 -33.496",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1445.26 255.059L1269.25 374.512L1282.75 453.621",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.64 237.011L1246.01 354.147",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.64 249.776L1299.23 125.214",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.94 143.279L1151.37 234.748L1088.58 304.675L1100.5 354.148L1117.68 454.22",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.64 446.319L1039.5 312.575C1039.5 312.575 1030.36 287.75 1039.5 262.364C1048.63 236.977 1041.18 214.962 1027.03 195.772C1012.87 176.583 1017.06 116.769 1017.06 116.769L975.021 91.3646L922.24 116.769L856.549 388.19L827.442 462.12L812.823 462.12L780.87 389.331L785.036 357.098L640.484 356.536",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.173 445.755C952.173 445.755 928.06 301.793 917.245 279.285C906.43 256.778 813.262 143.276 813.262 143.276L724.311 15.7466L708.528 -56.4803L627.029 -56.4803C627.029 -56.4803 545.529 -107.271 508.014 -119.683C470.498 -132.096 417.458 -136.608 363.306 -130.41L286.542 -83.3943",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.544 32.0772L-73.22 97.5625",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.134 186.1L122.223 186.1",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.487 -132.232L92.5217 -32.4769L115.73 78.5847L143.879 199.32L399.969 330.624",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4805 174.879L31.6945 -25.9836",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.15 134.061L17.4388 150.477L-26.6486 137.643",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.15 168.683L186.466 159.764L122.224 -136.623",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.224 251.636L256.116 126.353L248.406 102.231L195.392 -118.558L195.392 -146.209L202.455 -241.066",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.972 314.28L298.496 354.343L294.046 314.28L423.255 201.919L389.155 186.118L197.876 354.361L210.243 383.118L263.593 415.281L286.62 458.733L310.164 454.783L301.859 394.407C301.859 394.407 404.135 385.383 468.972 353.781L595.413 335.716L475.673 242.667L496.372 106.096L496.372 52.7598L490.136 -21.8723C490.136 -21.8723 472.025 -66.0442 538.648 -106.371",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.57 -316.822L433.242 -62.6938L457.64 64.8357L595.414 335.713L636.629 386.767C636.629 386.767 687.185 411.03 702.708 442.947",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.946 357.098L785.036 357.098C785.036 357.098 684.002 328.305 673.369 304.429C673.369 304.429 602.322 268.93 598.984 236.942C598.984 236.942 559.735 239.049 541.106 228.971",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.301 290.543C537.301 290.543 613.859 260.293 637.818 247.881C661.776 235.469 652.669 201.602 673.367 184.292C694.065 166.981 702.189 162.961 702.759 158.958C703.328 154.955 702.759 130.113 702.759 130.113L772.124 84.2205L816.962 106.412L922.29 116.77",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.191 165.313L1020.71 180.745L1039.49 188.435L1029.38 199.092",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297.47 108.569L1299.23 172.633L1281.9 237.012L1227.67 205.112L1081.23 143.278L1017.04 116.751",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.06 101.899L1238.28 100.021L1216.7 69.9292C1216.7 69.9292 1169.01 60.1504 1139.08 48.4754C1109.14 36.8004 1004.36 -20.5212 1004.36 -20.5212C1004.36 -20.5212 983.842 -14.7276 952.225 -17.3611C920.609 -19.9945 914.166 -30.5107 867.776 -29.0185L975.071 91.3656L989.948 85.73L1067.13 -10.0576L1113.1 -67.3089",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.725 5.02381L975.02 17.2957L1267.9 160.205L1299.23 172.635L1351 191.121L1471.44 272.846L1296.46 391.58L1244.12 358.855",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.25 100.017L1039.49 308.06L922.238 445.755",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.06 334.434C1017.06 334.434 962.161 318.984 937.763 314.454C913.365 309.925 876.315 306.572 876.315 306.572C876.315 306.572 790.934 290.771 757.584 282.484C724.234 274.198 637.405 278.007 611.273 260.117",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.342 323.302L475.673 242.542C475.673 242.542 466.514 221.65 423.28 201.899",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.18 186.1C389.18 186.1 357.563 162.469 341.781 136.52C325.998 110.572 302.687 59.7991 302.687 59.7991L293.036 60.7822L260.592 -90.7819L267.758 -251.159",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.902 354.326L194.28 340.035L122.224 304.677",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.862 315.789L341.755 136.503L616.008 77.6193",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.649 61.4481C556.5 74.4047 546.358 59.2009 516.423 52.6699C486.488 46.1389 475.673 64.8189 449.464 68.1897C438.468 69.6118 421.702 69.84 405.946 69.6293C383.492 69.1945 361.496 73.99 343.618 83.218C316.167 97.6669 280.773 102.109 280.773 102.109L256.116 126.372L294.071 314.225C294.071 314.225 231.2 366.385 207.656 377.094C207.656 377.094 170.916 387.452 167.035 441.245C167.035 441.245 145.406 422.425 117.67 414.911",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1737.1 146.457L616.006 -277.705L563.64 -290.714L498.932 -307.042L425.97 -302.512L122.222 -219.014L-47.4521 -152.985",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.74 -224.649L65.3021 -131.495L19.6365 -25.981L-10.2985 246.283",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775.11 135.869L646.148 -289.557L499.759 -326.232L425.97 -302.514",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807.22 128.038L757.61 -268.227C757.61 -268.227 691.065 -293.49 681.078 -299.828C681.078 -299.828 573.525 -312.996 528.066 -328.059C482.608 -343.122 352.312 -395.388 331.794 -453.324",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.721 -290.486L1869.5 117.752",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613.28 128.038L1701.74 25.5264L747.055 -332.624L712.126 -295.755",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1611 -8.51374L1533.8 82.8496",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520.45 -42.4846L1448.31 45.6484",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1432.04 -75.652L1363.27 5.01953",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.48 11.0283L1367.38 -99.9104C1367.38 -99.9104 1389.63 -116.571 1392.12 -128.422C1394.6 -140.272 1405.05 -158.9 1434.94 -156.635L1472.37 -196.435",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1975.08 43.5771L1224.41 -238.571L846.173 -376.933L800.818 -403.355",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1848.98 110.097L1930.74 13.8702",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1882.07 116.4L1915.21 75.9329",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.15 -18.4851L1984.22 102.32",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.49 149.933L1848.98 -32.4781L1909.78 -61.6392",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1839.67 -21.3132C1877.64 -2.84994 1919.32 11.8188 1963.44 22.2441",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750.64 -123.792L1647.09 5.01953",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1701.74 25.5293L1771.05 -59.3733L1847.51 -30.7213",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1681.17 -37.3597L1972.86 69.541",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1701.76 150.461L1649.11 209.31",
    stroke: "#F2F2F5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1803.13 128.864C1807.09 140.188 1827.79 152.723 1827.79 152.723L1845.9 162.116C1845.9 162.116 1908.98 241.225 1956.38 255.867",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.58 186.45C1789.58 186.45 1749.29 171.352 1739.74 146.422",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750.15 275.32L1845.77 162.187L1881.04 136.081",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845.77 162.187L1976.32 207.886",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1953.87 166.453C1953.87 166.453 1873.35 152.408 1877.23 136.414",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1948.88 170.93L1886.52 266.577L1860.31 332.044L1810.56 343.421",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1956.38 335.435L1913.12 296.214L1920.98 236.434",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1982.15 287.171L1886.52 266.577L1759.25 223.16",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22.4835 346.669L48.4858 289.242",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6909 275.32L-19.7158 280.973",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6909 195.192L-26.6497 200.845",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.328 -49.9114L122.224 219.456L388.896 -28.2643L439.297 -94.8556L439.297 -132.233",
    stroke: "#F2F2F5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderMapInsightProblems);
export default __webpack_public_path__ + "static/media/placeholder_map_insight_problems.c38316f54c530bc38581dd10d914e9c3.svg";
export { ForwardRef as ReactComponent };